const {
  BODY_ELEMENTS,
  BODY_EVENTS,
  LIST_NAMES,
} = require('./analyticsConst');
const impressions = require('./impressions/index');
const analyticUtils = require('./analyticUtils');
const { getDoubleLookPIDWithoutSize, getOriginalPID } = require('../common/utils/doubleLookUtils');
const { addDocumentDelegatedListener, onOnce } = require('../common/utils/domEvents');
const { analyticsEventCenter, ANALYTICS_EVENTS } = require('./events');
const { default: getFrontConfig } = require('../common/getFrontConfig');
const { getPidFromQueryString } = require('../common/utils/queryString');
const { cartItemListStorage, getItemListForProductID } = require('./stores/itemList');
const { searchDataStorage } = require('./stores/searchData');
const { findProductInCart, getCartFromLocalStorage } = require('../cart/localCart');

const FRONT_CONFIG = getFrontConfig();

impressions.init();

/* -------------------------------------------------------------------------- *\
 * CART                                                                       *
\* -------------------------------------------------------------------------- */
// Add to cart
// Listen to product:beforeAddTocart event to get pid and add to cart context
$('body').on(BODY_EVENTS.addToCart, (event, data) => {
  if (!data) return;
  // In Shop the look and Fit Analytics, data is a plain object with event data
  let addToCartPlace = data.addToCartPlace || gaInfo.pageType; // Provided by event or default
  let { pid } = data;

  const currentTarget = data instanceof jQuery ? data[0] : data;
  if (currentTarget instanceof HTMLElement) {
    // Get event target context to get pid
    const container = currentTarget.closest('.product-detail');
    if (container) {
      pid = container.classList.contains('product-detail-vue')
        ? container.querySelector('.product-id').innerText
        : container.dataset.productId;
    }

    // Special cases for Save for later, Wishlist and Search, as they are not pageType (modal behaviour)
    if (currentTarget.closest('.save-for-later-container')) {
      addToCartPlace = LIST_NAMES['save-for-later'];
    } else if (currentTarget.closest('.wishlist-container')) {
      addToCartPlace = LIST_NAMES.wishlist;
    } else if (currentTarget.closest('.the-search__results')) {
      addToCartPlace = LIST_NAMES.search;
    }
  }

  if (pid) {
    analyticUtils.handleDimensionsData(getOriginalPID(pid), addToCartPlace);
  }
});

$('body').on(BODY_EVENTS.addedToCart, (event, data) => {
  if (data.error || !data.product) return;

  const {
    cart,
    doubleLookPID,
    product,
    position,
  } = data;
  const productLineItem = cart.items.find((item) => item.UUID === data.pliUUID);

  const pidWithoutSize = getDoubleLookPIDWithoutSize(product.id);
  const list = (data.context && LIST_NAMES.contextList[data.context])
    || getItemListForProductID(pidWithoutSize);
  const searchData = list === LIST_NAMES.search
    && searchDataStorage.getItem(pidWithoutSize);

  let contextAddToCart;
  if (data.context === FRONT_CONFIG.vue.BaseProductTile.context.plpGrid) {
    contextAddToCart = ANALYTICS_EVENTS.PAYLOADS.productAddedToCart.context.category;
  } else if (data.context === FRONT_CONFIG.vue.BaseProductTile.context.minicartSlider) {
    contextAddToCart = ANALYTICS_EVENTS.PAYLOADS.productAddedToCart.context.cart;
  } else {
    contextAddToCart = ANALYTICS_EVENTS.PAYLOADS.productAddedToCart.context.product;
  }

  analyticsEventCenter.publish(ANALYTICS_EVENTS.productAddedToCart, {
    cart,
    context: searchData?.query
      ? ANALYTICS_EVENTS.PAYLOADS.productAddedToCart.context.search
      : contextAddToCart,
    doubleLookPID,
    list,
    product,
    productLineItem,
    position: parseInt(position, 10),
    searchData,
  });

  analyticUtils.updateCartGaInfo(data.cart);
});

// Remove from cart
$('body').on(BODY_EVENTS.removeFromCart, (event, data) => {
  if (data.error) return;

  // publish
  const product = findProductInCart(data.pid);
  analyticsEventCenter.publish(
    analyticsEventCenter.EVENTS.productRemovedFromCart,
    {
      cart: data.basket,
      product,
    },
  );

  analyticUtils.updateCartGaInfo(data.basket);
});

// Update quantity
$('body').on(BODY_EVENTS.updateQuantity, (event, data) => {
  if (data.error) return;
  const cartFromLocalStorage = getCartFromLocalStorage();
  if (cartFromLocalStorage) {
    const pid = getPidFromQueryString(data.queryString);
    const itemList = cartItemListStorage.getItem(pid);
    const productFromLocalStorage = findProductInCart(pid, cartFromLocalStorage);
    const pidWithoutSize = getDoubleLookPIDWithoutSize(pid);
    const searchData = itemList === LIST_NAMES.search
      && searchDataStorage.getItem(pidWithoutSize);

    const updatedProduct = {
      ...findProductInCart(pid, data),
      doubleLookPID: productFromLocalStorage?.doubleLookPID,
    };

    const productLineItem = data.items.find((item) => item.id === pid);

    if (updatedProduct.quantity < productFromLocalStorage?.quantity) {
      analyticsEventCenter.publish(ANALYTICS_EVENTS.productRemovedFromCart, {
        product: updatedProduct,
      });
    } else {
      analyticsEventCenter.publish(ANALYTICS_EVENTS.productAddedToCart, {
        context: ANALYTICS_EVENTS.PAYLOADS.productAddedToCart.context.cart,
        list: itemList,
        product: updatedProduct,
        productLineItem,
        searchData,
      });
    }

    if (pid) {
      analyticUtils.handleDimensionsData(getOriginalPID(pid), LIST_NAMES.cart);
    }
  }
});

/* -------------------------------------------------------------------------- *\
 * CHECKOUT                                                                   *
\* -------------------------------------------------------------------------- */
// Cart landing page is viewed (1st step of checkout funnel)
function sendCheckoutFirstStep() {
  analyticsEventCenter.publish(
    ANALYTICS_EVENTS.checkoutCartViewed,
  );
}
document.addEventListener('analytics-checkoutFirstStep', sendCheckoutFirstStep);

/* -------------------------------------------------------------------------- *\
 * LOGIN                                                                      *
\* -------------------------------------------------------------------------- */
// Forgot your password form is open when clicking in link on Login Page
$('body').on('click', BODY_ELEMENTS.forgotPassword, () => {
  analyticsEventCenter.publish(ANALYTICS_EVENTS.loginForgotPasswordOpened);
});

/* -------------------------------------------------------------------------- *\
 * PDP                                                                        *
\* -------------------------------------------------------------------------- */
// Fit Analytics link click
$('body').on('click', BODY_ELEMENTS.pdpFitAnalyticsLink, () => {
  analyticsEventCenter.publish(
    ANALYTICS_EVENTS.productDetailsItemClicked,
    ANALYTICS_EVENTS.PAYLOADS.productDetailsItemClicked.item.fitAnalytics,
  );
});

/* -------------------------------------------------------------------------- *\
 * ATC NUMBER EVENTS                                                          *
\* -------------------------------------------------------------------------- */
const atcPhoneNumberSelector = '.contact-text__number,.phone';
$('body').on('click', atcPhoneNumberSelector, (event) => {
  let location;
  const isInsideMinicart = !!event.target.closest('.minicart-popup');
  if (isInsideMinicart) {
    location = ANALYTICS_EVENTS.PAYLOADS.atcPhoneClicked.location.minicart;
  } else {
    const page = document.querySelector('.page');
    if (page?.classList.contains('page--checkout')) {
      location = ANALYTICS_EVENTS.PAYLOADS.atcPhoneClicked.location.checkout;
    } else if (page?.classList.contains('page--cart')) {
      location = ANALYTICS_EVENTS.PAYLOADS.atcPhoneClicked.location.cart;
    }
  }
  if (location) {
    analyticsEventCenter.publish(ANALYTICS_EVENTS.atcPhoneClicked, location);
  }
});

/* -------------------------------------------------------------------------- *\
 * CHAT EVENT                                                                 *
\* -------------------------------------------------------------------------- */
function handleChatOpened() {
  analyticsEventCenter.publish(
    ANALYTICS_EVENTS.chatOpened,
  );
}
document.addEventListener('chat:opened', handleChatOpened);

/* -------------------------------------------------------------------------- *\
 * FAQ EVENTS                                                                 *
\* -------------------------------------------------------------------------- */
addDocumentDelegatedListener('click', BODY_ELEMENTS.clickFaqSection, (e) => {
  analyticsEventCenter.publish(
    ANALYTICS_EVENTS.faqsItemclicked, {
      item: e.target.dataset.section,
      option: e.target.href.split('q=')?.pop(),
    },
  );
});

/* -------------------------------------------------------------------------- *\
 * VIRTUAL TRY-ON EVENTS                                                      *
\* -------------------------------------------------------------------------- */
function handleVirtualTryOnClicked() {
  analyticsEventCenter.publish(
    ANALYTICS_EVENTS.virtualTryOnClicked,
  );
}
document.addEventListener('virtualTryOn:clicked', handleVirtualTryOnClicked);

/* -------------------------------------------------------------------------- *\
 * WISHLIST EVENTS                                                            *
\* -------------------------------------------------------------------------- */
addDocumentDelegatedListener('click', BODY_ELEMENTS.wishlistLogin, () => {
  analyticsEventCenter.publish(
    ANALYTICS_EVENTS.wishlistLoginLinkClicked,
  );
});

/* -------------------------------------------------------------------------- *\
 * MODALS EVENTS                                                              *
\* -------------------------------------------------------------------------- */
// Click on confirm address in Vertex suggesting address modal in checkout
function confirmAddressVertexModal() {
  analyticsEventCenter.publish(
    analyticsEventCenter.EVENTS.modalVertexSuggestedAddressConfirmed,
  );
}
document.addEventListener('suggestedAddressSelected', confirmAddressVertexModal);

/* -------------------------------------------------------------------------- *\
 * EQUALWEB (ACCESSIBILITY) EVENTS                                            *
\* -------------------------------------------------------------------------- */
const toggleAccessibilityType = `${BODY_ELEMENTS.accessibilityOpenIcon}, ${BODY_ELEMENTS.accessibilityCloseIcon}`;
addDocumentDelegatedListener(
  'click',
  toggleAccessibilityType,
  (event) => {
    const target = event?.target?.closest(toggleAccessibilityType);
    const clickAction = target.matches(BODY_ELEMENTS.accessibilityOpenIcon)
      ? ANALYTICS_EVENTS.PAYLOADS.accessibilityIconClicked.action.open
      : ANALYTICS_EVENTS.PAYLOADS.accessibilityIconClicked.action.close;

    analyticsEventCenter.publish(
      ANALYTICS_EVENTS.accessibilityIconClicked, {
        action: clickAction,
        pageType: gaInfo.pageType,
      },
    );
  },
);

/* -------------------------------------------------------------------------- *\
 * BIRTHDAY LANDING EVENTS                                                    *
\* -------------------------------------------------------------------------- */
addDocumentDelegatedListener(
  'click',
  BODY_ELEMENTS.birthdayShortcutItem,
  (event) => {
    let item = event.target.dataset.id;
    if (!item) {
      item = event.target.parentNode.dataset.id;
    }
    if (item) {
      analyticsEventCenter.publish(
        ANALYTICS_EVENTS.birthdayLandingItemClicked,
        item,
      );
    }
  },
);

/**
 * It removes all the event listeners
 */
function removeEventListeners() {
  document.removeEventListener('analytics-checkoutFirstStep', sendCheckoutFirstStep);
  document.removeEventListener('chat:opened', handleChatOpened);
  document.removeEventListener('suggestedAddressSelected', confirmAddressVertexModal);
  document.removeEventListener('virtualTryOn:clicked', handleVirtualTryOnClicked);
}

onOnce(window, 'beforeunload', () => {
  removeEventListeners();
});
